import {
  AsyncPipe,
  NgIf,
} from '@angular/common';
import {
  Component,
  inject,
} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  startWith,
} from 'rxjs/operators';
import { ThemedLangSwitchComponent } from 'src/app/shared/lang-switch/themed-lang-switch.component';

import { ContextHelpToggleComponent } from '../../../../app/header/context-help-toggle/context-help-toggle.component';
import { HeaderComponent as BaseComponent } from '../../../../app/header/header.component';
import { ThemedSearchNavbarComponent } from '../../../../app/search-navbar/themed-search-navbar.component';
import { ThemedAuthNavMenuComponent } from '../../../../app/shared/auth-nav-menu/themed-auth-nav-menu.component';
import { ImpersonateNavbarComponent } from '../../../../app/shared/impersonate-navbar/impersonate-navbar.component';

/**
 * Represents the header with the logo and simple navigation
 */
@Component({
  selector: 'ds-themed-header',
  styleUrls: ['header.component.scss'],
  // styleUrls: ['../../../../app/header/header.component.scss'],
  templateUrl: 'header.component.html',
  // templateUrl: '../../../../app/header/header.component.html',
  standalone: true,
  imports: [RouterLink, ThemedLangSwitchComponent, NgbDropdownModule, ThemedSearchNavbarComponent, ContextHelpToggleComponent, ThemedAuthNavMenuComponent, ImpersonateNavbarComponent, TranslateModule, AsyncPipe, NgIf],
})
export class HeaderComponent extends BaseComponent {

  private router = inject(Router);

  private translate = inject(TranslateService);

  /**
   * BfS: Sprachabhängiges Logo – "en" erhält das englische Logo (PNG), alle anderen Sprachen das deutsche (SVG).
   */
  logoSrc$: Observable<string> = this.translate.onLangChange.pipe(
    map((event) => event.lang),
    startWith(this.translate.currentLang),
    map((lang: string) => lang === 'en' ? 'assets/bfs/images/bfs-logo-en.svg' : 'assets/bfs/images/bfs-logo-de.svg'),
    distinctUntilChanged(),
  );

  /**
   * BfS: true auf der Startseite (`/` bzw. `/home`) – dort wird die Suchleiste im Header ausgeblendet,
   * weil die Startseite bereits ein eigenes Suchfeld hat.
   */
  isHomePage$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.urlAfterRedirects),
    startWith(this.router.url),
    map((url: string) => ['/', '/home'].includes(url.split(/[?#]/)[0])),
    distinctUntilChanged(),
  );
}
